export interface TransportTrack {
  id?: string;
  title?: string;
  artist?: string;
  album?: string;
  artUrl?: string;
  artworkUrl?: string;
  duration?: number;
  formatId?: number;
  qobuzTrackId?: string;
  serviceTrackId?: string;
  source?: string;
  file_path?: string;
  machine_id?: string;
  bitDepth?: number;
  sampleRate?: number;
  /** Channel count for the file. Plumbed into DIDL nrAudioChannels for UPnP renderers. */
  channels?: number;
  format?: string;
  albumId?: string;
  streamUrl?: string;
}

export type ActiveSource = 'library' | 'radio';
export type RepeatMode = 'off' | 'one' | 'all';

/**
 * Returns true for renderers that only support CD quality (16-bit/44.1kHz).
 * Sonos devices max at 16-bit/48kHz — sending hi-res causes
 * TRANSITIONING -> STOPPED immediately.
 */
export function isLimitedRenderer(
  renderer: { id: string; name?: string; manufacturer?: string } | null | undefined,
): boolean {
  if (!renderer) return false;
  const n = (renderer.name || '').toLowerCase();
  const m = ((renderer as any).manufacturer || '').toLowerCase();
  return n.includes('sonos') || n.includes('rincon')
    || m.includes('sonos') || m.includes('rincon');
}

/**
 * Determine the Qobuz format_id for a given renderer.
 * Limited renderers (Sonos) get format 6 (CD 16-bit/44.1kHz).
 * Everything else gets format 27 (hi-res 24-bit/192kHz).
 *
 * The format is a function of the RENDERER capability, not the track.
 * Qobuz automatically downgrades if a track doesn't support hi-res.
 * Never use track.formatId here — it leaks Sonos format contamination
 * across zone switches and localStorage-restored queues.
 */
export function getFormatIdForRenderer(
  renderer: { id: string; name?: string; manufacturer?: string } | null | undefined,
): number {
  return isLimitedRenderer(renderer) ? 6 : 27;
}
